import DOMPurify from 'dompurify';

// Matches hrefs that already carry a scheme (e.g. `https:`, `mailto:`, `tel:`)
// or are intentionally relative (`//host`, `/path`, `?query`, `#anchor`). Anything
// else is a bare host like `google.com` that the browser would otherwise resolve
// relative to the app origin (→ popularpays.com/google.com).
const HAS_SCHEME_OR_RELATIVE = /^([a-z][a-z0-9+.-]*:|\/\/|\/|\?|#)/i;

function prependHttpsToSchemelessLinks(node: Element): void {
  if (node.tagName !== 'A') {
    return;
  }
  const href = node.getAttribute('href');
  if (href && !HAS_SCHEME_OR_RELATIVE.test(href)) {
    node.setAttribute('href', `https://${href}`);
  }
}

/**
 * Sanitizes backend-generated message HTML (Redcarpet `body_html`) for injection
 * via `dangerouslySetInnerHTML`, and normalizes schemeless link hrefs to absolute
 * `https://` URLs so they don't resolve relative to the app origin. Mirrors the
 * protocol-prepending behavior already applied client-side in `formatMessageBody`.
 */
export default function sanitizeMessageHtml(html: string): string {
  DOMPurify.addHook('afterSanitizeAttributes', prependHttpsToSchemelessLinks);
  try {
    return DOMPurify.sanitize(html, {ADD_ATTR: ['target']});
  } finally {
    DOMPurify.removeHook('afterSanitizeAttributes');
  }
}
